import type * as React from "react";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/cn";

export const badgeVariants = cva(
  "inline-flex items-center rounded-3xl px-2.5 py-0.5 text-body-caption-m-bold transition-colors",
  {
    variants: {
      variant: {
        blue: "text-badge-text-blue bg-badge-bg-light-gray",
        red: "text-badge-text-red bg-badge-bg-light-gray",
        green: "text-badge-text-green bg-badge-bg-light-green",
        yellow: "text-badge-text-yellow bg-badge-bg-light-yellow",
        gray: "text-badge-text-gray bg-badge-bg-light-gray",
        purple: "text-primary bg-badge-bg-light-purple",
      },
    },
    defaultVariants: {
      variant: "gray",
    },
  },
);

export interface BadgeProps
  extends React.ComponentProps<"div">, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, className }))} {...props} />
  );
}
